<template>
  <div class="checkin-banner" ref="checkinBanner" v-if="picaServiceId">

    <div class="container" v-if="banner">
      <div class="row-small-gutters">
        <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
          <template v-if="banner.link || banner.email">
            <a :href="bannerAction" target="_blank">
              <div class="checkin-banner__image-w">
                <img ref="bannerImage" :src="banner.url" alt="Banner" class="img-fluid cursor-pointer checkin-banner__image">
              </div>
            </a>
          </template>
          <template v-else>
            <div class="checkin-banner__image-w">
              <img ref="bannerImage" :src="banner.url" alt="Banner" class="img-fluid checkin-banner__image">
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- OLD BANNERS -->
    <div class="old-banners" v-else>
      <div class="container" v-if="picaServiceId === 2430">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.fondazionecomunitamilano.org/fondi/fondo-fondazione-g-ponzone/"
               target="_blank">
              <img src="../../assets/banners/ponzone.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2405">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://grangala.assocalciatori.it/"
               target="_blank">
              <img src="../../assets/banners/Banner-Gala.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2406">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://business.getpica.com/?utm_source=getpica.com&utm_medium=banner&utm_campaign=TRC23"
               target="_blank">
              <img src="../../assets/banners/pica_EN.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2391">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://pages.awscloud.com/awsmp-webinar-ew-red-hat-rosa-cloud-app-mwcat-ty.html?trk=d82b9dfd-f21b-43a7-b82e-0a8f56675bb0&sc_channel=psm"
               target="_blank">
              <img src="../../assets/banners/banner-aws.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2351">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://genoacfc.vivaticket.it/it/event/serie-a-tim-2023-2024-genoa-cfc-empoli/224952"
               target="_blank">
              <img src="../../assets/banners/genoa-empoli.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2385">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://business.getpica.com/"
               target="_blank">
              <img src="../../assets/banners/pica_EN.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2388">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <img src="../../assets/banners/topul.png" alt="Banner" class="img-fluid cursor-pointer"
                 style="max-height: 22rem"/>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2363">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.mgmotor.it/"
               target="_blank">
              <img src="../../assets/banners/banner-MG.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2342">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://business.getpica.com/" target="_blank">
              <img src="../../assets/banners/loop.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2335">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://genoacfc.vivaticket.it/it/event/serie-a-tim-2023-2024-genoa-cfc-hellas-verona/223364"
               target="_blank">
              <img src="../../assets/banners/genoa-verona.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2330">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.k-way.com/" target="_blank">
              <img src="../../assets/banners/kway.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2326">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.caesars.com/myrewards/sevenstars" target="_blank">
              <img src="../../assets/banners/seven-stars.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2312">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.phocuswire.com/Phocuswright-Conference-2023/phocuswright-conference-2023/55288"
               target="_blank">
              <img src="../../assets/banners/pcwire.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2281">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">

            <img src="../../assets/banners/Horizons.png" alt="Banner" class="img-fluid cursor-pointer"
                 style="max-height: 22rem"/>

          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2313">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://gbtafoundation.org/people/winit/" target="_blank">
              <img src="../../assets/banners/BWBV.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>

      <div class="container" v-else-if="picaServiceId === 2296">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.blastness.com/" target="_blank">
              <img src="../../assets/banners/blastness.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2309">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.youtube.com/watch?v=A9M-2QPOaic" target="_blank">
              <img src="../../assets/banners/emozioniRete.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2292">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://business.getpica.com" target="_blank">
              <img src="../../assets/banners/SportBiz.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2295 || picaServiceId === 2382 || picaServiceId === 2394">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.alaskaair.com/huskies" target="_blank">
              <img src="../../assets/banners/banner-alaska2.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2289">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.inter.it/it/tickets/intersalisburgo?utm_source=inter.it&utm_medium=referral&utm_campaign=pica-intersalisburgo"
               target="_blank">
              <img src="../../assets/banners/banner-inter2.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style=""/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2266">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.campari.com/our-products/campari-negroni/" target="_blank">
              <img src="../../assets/banners/banner-campari-2.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2237">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://bit.ly/48iSveX" target="_blank">
              <img src="../../assets/banners/banner-bmw-rinascente.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2236">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.brooksrunning.com/en_it/adrenaline/" target="_blank">
              <img src="../../assets/banners/banner-brooks.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2172">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://trunsylvania.com/brf2024/select_competition" target="_blank">
              <img src="../../assets/banners/banner-brf.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2178">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a :href="`https://bees.luxochain.io/newDash/blue_note/${currentUser.email}`" target="_blank">
              <img src="../../assets/banners/banner-blue-note.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1994">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.uber.com/it/en/drive/?uclick_id=7e4c583a-6543-4140-9916-7ecdc47e6e27" target="_blank">
              <img src="../../assets/banners/banner-uber.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2015
          || picaServiceId === 2016
          || picaServiceId === 2017
          || picaServiceId === 2064
          || picaServiceId === 2074
          || picaServiceId === 2075
          || picaServiceId === 2076
          || picaServiceId === 2077
          || picaServiceId === 2078">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://landing.luiss.it/summer-school/index.php" target="_blank">
              <img src="../../assets/banners/banner-LUISS.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2169">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.thebta.org.uk/events-8723" target="_blank">
              <img src="../../assets/banners/banner-bta.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2201">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.pawpatrol.movie/" target="_blank">
              <img src="../../assets/banners/banner-paw-patrol.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 29rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2189">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.phocuswrightconference.com/" target="_blank">
              <img src="../../assets/banners/banner-phocus.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2227">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://it.lorealoneretail.com/wall" target="_blank">
              <img src="../../assets/banners/banner-loreal.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2202">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://store.cagliaricalcio.com/" target="_blank">
              <img src="../../assets/banners/banner-cagliari-store.png" alt="Banner"
                   class="full-width-mobile img-fluid cursor-pointer"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2308">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="mailto:sponsor@gbta.org" target="_blank">
              <img src="../../assets/banners/gbta.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2324">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a :href="getJupilerBannerUrl()" target="_blank">
              <img src="../../assets/banners/banner_jupiler2.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2177">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a :href="getJupilerBannerUrl()" target="_blank">
              <img src="../../assets/banners/banner-jupiler.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2210">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://bit.ly/3rjWJCe" target="_blank">
              <img src="../../assets/banners/banner-palate.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2174">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://booking.senigalliaincoming.it/en/hd-event" target="_blank">
              <img src="../../assets/banners/banner-ebw-after.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2023 || picaServiceId === 2024">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.instagram.com/bkt.sport/" target="_blank">
              <img src="../../assets/banners/banner-btk.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2088">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.facebook.com/groups/994074700710066/media/photos" target="_blank">
              <img src="../../assets/banners/banner-hog.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2072">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.titosvodka.com/love" target="_blank">
              <img src="../../assets/banners/banner-titos.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2033">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.adidas.it/scarpe-da-calcio-predator-accuracy.3-firm-ground/GW4589.html"
               target="_blank">
              <img src="../../assets/banners/banner-demo-juve.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2034">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.rolex.com/it/watches/submariner/m124060-0001" target="_blank">
              <img src="../../assets/banners/banner-demo-rolex.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1998">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.supercars.com/tickets/" target="_blank">
              <img src="../../assets/banners/banner-rush.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1984">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.legalcommunityweek.com/photo-2023/" target="_blank">
              <img src="../../assets/banners/legal.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1983">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.championstore.com/it_it/" target="_blank">
              <img src="../../assets/banners/banner-champ2.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1974">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://store.google.com/intl/en/ideas/pixel-is-open/" target="_blank">
              <img src="../../assets/banners/banner-pixel.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1967">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://store.cagliaricalcio.com/it/categoria/64/kit-gara" target="_blank">
              <img src="../../assets/banners/banner-cagliari.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1941">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://secure.bankofamerica.com/apply-credit-cards/public/icai-single/#/info/" target="_blank">
              <img src="../../assets/banners/banner-alaska.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1964">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.plandeviata.ro/" target="_blank">
              <img src="../../assets/banners/banner-imatters.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1899 || picaServiceId === 1921">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://share.hsforms.com/1hb4wS98XRQib51kqKfNepw5fzkj" target="_blank">
              <img src="../../assets/banners/banner-GBTA-BNO.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1935">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.drinkmonaco.com/monaco-cocktails#Hardlemon" target="_blank">
              <img src="../../assets/banners/banner-UFC.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1943">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.instagram.com/espolontequilaitalia/" target="_blank">
              <img src="../../assets/banners/banner-espolon.jpeg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1902">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://share.hsforms.com/10LggEt6MQX6zXS0wNw7x2Q5fzkj" target="_blank">
              <img src="../../assets/banners/banner-wingo.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1737">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://meridiani.it/en" target="_blank">
              <img src="../../assets/banners/meridiani.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1773">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.instagram.com/bkt.sport/" target="_blank">
              <img src="../../assets/banners/BKT-banner-getpica.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1772 || picaServiceId === 2019">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.ussoccer.com/insiders" target="_blank">
              <img src="../../assets/banners/us_soccer_insider.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1777">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">

            <img src="../../assets/banners/persol.png" alt="Banner" class="img-fluid cursor-pointer"
                 style="max-height: 22rem"/>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1776">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">

            <img src="../../assets/banners/banner-les-collectionneurs.png" alt="Banner" class="img-fluid cursor-pointer"
                 style="max-height: 22rem"/>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1910">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://us.coca-cola.com/store/" target="_blank">
              <img src="../../assets/banners/banner-cocacola.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1908">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.transformersmovie.com/" target="_blank">
              <img src="../../assets/banners/banner-transformers.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2090">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.expoaid.it/" target="_blank">
              <img src="../../assets/banners/expoaid.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2120">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://financecommunityweek.com/photos/" target="_blank">
              <img src="../../assets/banners/LCW.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2238">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.inter.it/it/tickets/interbenfica?utm_source=inter.it&utm_medium=referral&utm_campaign=pica-interbenfica"
               target="_blank">
              <img src="../../assets/banners/banner-inter.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2345">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://store.inter.it/it-it/christmas-collection.html?utm_source=inter.it&utm_medium=referral&utm_campaign=pica-xmas"
               target="_blank">
              <img src="../../assets/banners/inter-xmas.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2052">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.ppatour.com/" target="_blank">
              <img src="../../assets/banners/patour.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 2051">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.ticketmaster.com/carolina-hurricanes-vs-ottawa-senators-raleigh-north-carolina-10-11-2023/event/2D005EF4A0414351?brand=carolinahurricanes?utm_source=pica&utm_medium=organic&utm_campaign=OpeningNight"
               target="_blank">
              <img src="../../assets/banners/banner-carolina.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1760">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.quinservizi.it/" target="_blank">
              <img src="../../assets/banners/avvera-2023.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>

          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1623 || picaServiceId === 2117">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.adidas.com/us/tour360-22-golf-shoes/GV7244.html" target="_blank">
              <img src="../../assets/banners/tour360.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1645">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.coccinelle.com/en/ss23/" target="_blank">
              <img src="../../assets/banners/allaboutus.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1624">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.instagram.com/bkt.sport/" target="_blank">
              <img src="../../assets/banners/bkt-sport.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1589">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://shop.asmonaco.com/products/maillot-collector-1999-00?utm_source=getapica&utm_medium=psg&utm_campaign=maillotretro99"
               target="_blank">
              <img src="../../assets/banners/monaco-kombat.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1473">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://store.asroma.com/it/kit-gara-22-23/esports-22-23.html" target="_blank">
              <img src="../../assets/banners/banner-roma-napoli.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1523">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://financecommunity.it/financecommunity-awards-2022/" target="_blank">
              <img src="../../assets/banners/finance-community-award.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1504">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://anlaidslombardia.it/sostienici/" target="_blank">
              <img src="../../assets/banners/convivio2022.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1567">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://nistalybello.com/" target="_blank">
              <img src="../../assets/banners/nistalybello.png" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="picaServiceId === 1680">
        <div class="row-small-gutters">
          <div class="col mt-3 mt-lg-0 text-center checkin-banner__wrap">
            <a href="https://www.getpica.com/preview/?ps=1680&ep=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaWNhY29kZSI6IkEwR0IwVEUxRiJ9.6bQB_MsZWNlw002_M6xXC4-_jm9I50LMiQ5ubEQoTUY"
               target="_blank">
              <img src="../../assets/banners/italgas-banner.jpg" alt="Banner" class="img-fluid cursor-pointer"
                   style="max-height: 22rem"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Gallery from "@/domain/metrics/gallery";
import {getBrowserLanguage} from "@/i18n";

export default {
  name: "StaticBanner",
  props: {
    picaServiceId: {
      type: Number,
      required: true,
    },
    banner: {
      type: Object,
      required: false,
    },
  },
  computed: {
    bannerAction() {
      return this.banner.link ? this.banner.link : `mailto:${this.banner.email}`
    }
  },

  mounted() {
    this.observeCheckinBanner()
    this.checkSize()

    let linkBanner = this.$refs.checkinBanner.querySelector('.checkin-banner__wrap a')
    if (linkBanner) {
      linkBanner.addEventListener('click', () => {
        Gallery.bannerClicked(0)
      })
    }
  },
  methods: {
    checkSize() {
      const img = this.$refs.bannerImage;
      if (img) {
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          if (width > height + 10) {
            img.classList.add('wide-image');
          }
        };
      }
    },
    observeCheckinBanner() {
      const banner = this.$refs.checkinBanner.querySelector('.checkin-banner__wrap')
      if (!banner) return

      setTimeout(() => {
        const observer = new IntersectionObserver(
            ([e]) => {
              if (e.intersectionRatio >= 1) {
                Gallery.bannerViewed(0)
              }
            }, {threshold: [1]}
        );
        observer.observe(banner)
      }, 2000)
    },
    getJupilerBannerUrl() {
      let lang = 'en'
      let availableSiteLangs = ['en', 'nl', 'fr']
      const userLang = getBrowserLanguage().toLowerCase()
      if (availableSiteLangs.includes(userLang)) {
        lang = userLang
      }
      if (this.$i18n.locale === 'fr') lang = 'fr'

      return `https://jupiler.be/${lang}/jupilerproleague`
    }
  }
}
</script>
<style scoped>

</style>
